import React from 'react';
import logo from './logo-dermpro.svg';


const Logo = () => {
  return (
    <div>
      <img src={logo} title="DermPro" alt="DermPro" />
    </div>
  );
};

export default Logo;
